import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type JiraHomeType from '@atlassian/jira-spa-apps-jira-home/src/index.tsx';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';

export const LazyJiraHomePage = lazyForPaint<typeof JiraHomeType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-home", jiraSpaEntry: "async-jira-home" */ '@atlassian/jira-spa-apps-jira-home'
		),
	),
);

// This component will redirect users from /jira/your-work to /jira/for-you.
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event.
// We can remove this component once the frequency of the operational event is 0.
const YourWorkRedirect = () => <ScreenRedirect to="/jira/for-you" />;

/**
 * This component is used to redirect users from /jira/your-work to /jira/for-you.
 * @returns The YourWorkRedirect component.
 */
export const ConditionalJiraHome = (): React.JSX.Element => {
	return <YourWorkRedirect />;
};
